module.exports = __webpack_public_path__ + "img/play-icon.09880cc7.svg";